// Fallback photos for staff who don't have a photo_url set in the Staff
// sheet tab yet. Keyed by a slugified version of their name (see
// utils/staffData.js#slugify). Once someone's photo_url is filled in on the
// sheet, that takes priority and this fallback is never used for them.
import comingSoon from './staff/coming_soon.jpg';
import lee from './staff/LeAndrena-Hadlock.jpg';
import joy from './staff/Joy-Quinney.jpg';
import karena from './staff/Karena-Soderborg.jpg';
import destanee from './staff/Destanee-Webb.jpg';
import nathan from './staff/Nathan-Hadlock.jpg';
import adelaide from './staff/Adelaide-Soderborg.jpg';
import riley from './staff/Riley-Temple.jpg';
import shawna from './staff/Shawna-Teenney.jpg';
import shanna from './staff/Shanna-Davies.jpg';
import alicia from './staff/Alicia-Pehrson.jpg';

export const STAFF_PHOTO_FALLBACKS = {
  'leandrena-hadlock': lee,
  'joy-quinney': joy,
  'karena-soderborg': karena,
  'destanee-webb': destanee,
  'nathan-hadlock': nathan,
  'adelaide-soderborg': adelaide,
  'riley-temple': riley,
  'shawna-teenney': shawna,
  'shanna-davies': shanna,
  'alicia-pehrson': alicia,
};

export const COMING_SOON_PHOTO = comingSoon;
